module.exports = require("chalk");;